import { LevelData } from '@app/interface/valoration-last-assessment.interface';

export function generateSeniorityLevelsMock(
  count: number,
  startId = 1
): LevelData[] {
  const levels: LevelData[] = [];

  for (let i = 0; i < count; i++) {
    const id = startId + i;
    const position = i + 1;
    const levelName = `L${position}`;

    // valores simulados con incrementos de 0.5
    const min = 2.5 + i * 0.5;
    const max = min + 0.4;

    levels.push({
      level_id: id,
      position,
      level_name: levelName,
      maximum_value_level: max.toFixed(1),
      minimum_value_level: min.toFixed(1),
    });
  }

  return levels;
}
